import { render, staticRenderFns } from "./CabinetHeader.vue?vue&type=template&id=7b1877dc&"
import script from "./CabinetHeader.vue?vue&type=script&lang=ts&"
export * from "./CabinetHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports